<script lang="ts" setup>
  import { BaseDatePicker } from '@qic/ui-components'
  import { useI18n } from 'vue-i18n'

  interface Props {
    errors?: string[]
    label?: string
    dataTest?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    dataTest: 'qid-expiry-date-input',
  })

  const modelValue = defineModel<Date | null>()

  const { locale } = useI18n()

  const getNowDate = () => new Date()
</script>

<template>
  <BaseDatePicker
    v-model="modelValue"
    name="qid-expiry-date-picker"
    :label="label || $t('outbound.personal_info.qid_exp_date')"
    :min-date="getNowDate()"
    :errors="errors"
    :start-date="getNowDate()"
    :locale="locale === 'en' ? 'en' : 'ar'"
    calendar-on-mobile
    :date-picker-options="{
      weekStart: 0,
    }"
    class="qid-expiry-date-input"
    :data-test="dataTest"
  />
</template>

<style>
  /* TODO: Fix bug with button "return to calendar" on year changing (it has wrong position on scroll). Now this styles is global, because the BaseDatePicker component cannot set a custom class for the calendar modal */
  .dp__overlay_action {
    position: fixed;
    bottom: 16px;
    width: 406px;
    margin: 0 auto;
    animation: show 0.3s ease-in;
  }

  @media (width <= 544px) {
    .dp__overlay_action {
      width: 308px;
    }
  }

  /* Animation is using to fix "jumping" interface on opening */
  @keyframes show {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .dp__overlay_row:last-child {
    padding-bottom: 60px; /* 56px is height + 4px as gap */
  }

  .dp__overlay {
    overflow-x: hidden;
  }

  .qid-expiry-date-input {
    .dp__menu_index > div {
      width: 422px !important;
    }

    .dp--menu-wrapper {
      top: -230px !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
    }

    .dp__overlay_container {
      height: 300px !important;
    }

    .dp__button_bottom {
      inset-inline: 0;
      height: 56px;
      border: 1px solid rgb(82 108 130 / 20%);
      border-radius: 12px;
      transition: 0.2s;
      background: #fff;

      &:hover {
        color: var(--primary);
        background: #fff;
        border: 1px solid var(--primary);
        box-shadow: 0 0 0 3px var(--focus-shadow);
      }
    }

    .dp__overlay_action {
      width: 406px;
      margin: 0 auto;
      animation: show 0.3s ease-in;
      position: absolute;
      bottom: 3px;
    }

    .dp__overlay_cell {
      border: 1px solid rgb(82 108 130 / 20%);
      border-radius: 12px;
      transition: 0.2s;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      height: 56px;
      align-items: center;
      display: flex;
      justify-content: center;

      &:hover {
        color: var(--primary);
        background: #fff;
        border: 1px solid var(--primary);
        box-shadow: 0 0 0 3px var(--focus-shadow);
      }
    }

    .dp__overlay_cell_active {
      background: #526c821a;
      border-color: transparent;
      color: #1c1c1c;
      border-radius: 12px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      height: 56px;
      align-items: center;
      display: flex;
      justify-content: center;
    }

    .dp__month_year_select {
      width: auto;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      padding: 8px 16px;
      height: 40px;
      border: 1px solid rgb(82 108 130 / 20%);
      border-radius: 12px;
      transition: 0.2s;

      &:hover {
        color: var(--primary);
        background: #fff;
        border: 1px solid var(--primary);
        box-shadow: 0 0 0 3px var(--focus-shadow);
      }
    }

    .dp__calendar_header_item {
      height: auto;
      width: 100%;
      padding: 0;
      color: #526c82cc;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }

    .dp__calendar_row {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      margin: 0;
    }

    .dp__cell_inner {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 58px;
      height: 48px;
      border-radius: 12px;
    }
  }

  @media (width <= 544px) {
    .dp__overlay_action {
      width: 308px;
    }

    .qid-expiry-date-input {
      .dp__menu_index > div {
        width: 324px !important;
      }

      .dp--menu-wrapper {
        top: -200px !important;
      }

      .dp__calendar_header,
      .dp__calendar {
        width: 308px !important;
      }

      .dp__cell_inner {
        width: 44px;
        height: 39px;
      }

      .dp__overlay_action {
        width: 100%;
      }

      .dp--overlay-absolute {
        top: -10px;
        overflow: hidden;
      }

      .dp__button.dp__overlay_action {
        height: 48px;
      }
    }
  }
</style>
